import AdminCMSList from "@/pages/admin/AdminCMSList";

const CATEGORIES = [
  { value: "general", label: "General" },
  { value: "lab", label: "Lab Notes" },
  { value: "kitchen", label: "Kitchen Confessions" },
  { value: "brand", label: "Brand Notes" },
  { value: "community", label: "Community" },
  { value: "announcement", label: "Announcement" },
];

export default function AdminJournal() {
  return (
    <AdminCMSList
      testIdPrefix="admin-journal" title="Journal Entry" subtitle="Pop Panda Journal"
      listEndpoint="/admin/journal"
      createEndpoint="/admin/journal"
      updateEndpoint={(id) => `/admin/journal/${id}`}
      deleteEndpoint={(id) => `/admin/journal/${id}`}
      visibilityKey="is_published"
      blank={{
        title: "", excerpt: "", body: "", cover_url: "",
        author: "Pop Panda Team", category: "general", tags: [],
        published_at: "", is_published: true,
      }}
      fields={[
        { key: "title", label: "Title", full: true },
        { key: "excerpt", label: "Excerpt (1-2 line summary)", type: "textarea", full: true, rows: 2 },
        { key: "body", label: "Article body", type: "textarea", full: true, rows: 8 },
        { key: "cover_url", label: "Cover image URL", full: true },
        { key: "author", label: "Author" },
        { key: "category", label: "Category", type: "select", options: CATEGORIES },
        { key: "published_at", label: "Publication date (YYYY-MM-DD)" },
        { key: "is_published", label: "Publish now (uncheck = save as draft)", type: "checkbox", help: "Published" },
      ]}
      renderCard={(p) => (
        <>
          {p.cover_url
            ? <img src={p.cover_url} alt={p.title} className="w-full aspect-[16/9] object-cover" />
            : <div className="w-full aspect-[16/9] bg-brand-muted grid place-items-center text-brand-charcoal/40 font-display text-4xl">No cover</div>}
          <div className="p-5">
            <div className="flex items-center justify-between gap-2">
              <div className="text-[10px] uppercase tracking-[0.22em] text-brand-red">{p.category || "general"}</div>
              <div className="text-[10px] uppercase tracking-[0.18em] text-brand-charcoal/55">{(p.published_at || p.created_at || "").slice(0, 10)}</div>
            </div>
            <div className="font-display text-xl mt-2 leading-tight">{p.title}</div>
            <p className="mt-2 text-xs text-brand-charcoal/65 line-clamp-2">{p.excerpt}</p>
          </div>
        </>
      )}
    />
  );
}
